define('models/shared/user/roleaccess',['backbone'], function (Backbone) {
    var RoleAccess = Backbone.Model.extend({
        initialize: function (options) {
            options = options || {};
            this.RoleID = options.RID;
            this.AccessModuleID = options.AMID;
            this.AccessFeatureID = options.AFID;
            this.AccessAttributeID = options.AAID;
            this.AccessTypeID = options.ATID;
        },
        parse: function (data) {
            var response = {};
            response.RoleID = data.RID;
            response.AccessModuleID = data.AMID;
            response.AccessFeatureID = data.AFID;
            response.AccessAttributeID = data.AAID;
            response.AccessTypeID = data.ATID;
            return response;
        },
    });

    return RoleAccess;
});

